import { createRoot } from "react-dom/client";
import TSNext from "./TSNext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<TSNext />);